/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Hints component for Profile tab
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.3.0
 */

import { Checkbox } from '../../../../../components/common';
import { IPageSettingsTranslation } from '../../../../../modules/internationalization/types/pages/pageSettings';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import Guard from '../../../../../modules/role/Guard';
import { PageSettingsHeaderStyled } from '../../styled/PageSettingsStyled';
import { ESettingsProfileComponents } from '../settingsProfileConstants';
import {
    ISettingsProfileParamsHints,
    ISettingsProfileParamsOnboarding,
    TSettingsProfileSetParamComponentActionPayload,
} from '../settingsProfileTypes';
import { SettingsProfileHintsContainerStyled } from '../styled/SettingsProfileStyled';

export interface ISettingsProfileHintsProps {
    params: ISettingsProfileParamsHints & ISettingsProfileParamsOnboarding;
    setParam: (payload: TSettingsProfileSetParamComponentActionPayload) => void;
    translation: IPageSettingsTranslation;
}

export const SettingsProfileHints = ({
                                         params,
                                         setParam,
                                         translation,
                                     }: ISettingsProfileHintsProps) => {
    return (
        <SettingsProfileHintsContainerStyled>
            <PageSettingsHeaderStyled>
                {translation.profile.hints.header}
            </PageSettingsHeaderStyled>
            <Checkbox
                checked={params.hintsIsEnabled}
                dataName="hintsCheckbox"
                label={translation.profile.hints.enable}
                onChange={hintsIsEnabled =>
                    setParam({ hintsIsEnabled, component: ESettingsProfileComponents.HINTS })}
            />
            <Guard accessKey={AccessComponentKeyEnum.onboarding}>
                <Checkbox
                    checked={params.onboardingIsDisabled}
                    dataName="onboardingCheckbox"
                    label={translation.profile.onboarding.enable}
                    onChange={onboardingIsDisabled =>
                        setParam({
                            onboardingIsDisabled,
                            component: ESettingsProfileComponents.ONBOARDING,
                        })}
                />
            </Guard>
        </SettingsProfileHintsContainerStyled>
    );
};
